import src from "IMAGE";
export default { src, width: 84, height: 107, blurWidth: 0, blurHeight: 0};
